var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: "标题" } },
    [
      _c("el-input", {
        attrs: { placeholder: "请输入标题" },
        model: {
          value: _vm.activeData.config.label,
          callback: function ($$v) {
            _vm.$set(_vm.activeData.config, "label", $$v)
          },
          expression: "activeData.config.label",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }